import { Settings, SystemDefault } from './constants';
import { v4 as generateUUID } from 'uuid';

const DOMAIN_REGEX = '^[0-9a-z-]+\\.[0-9a-z-.]+$';
export const getDomainName = () => {
  const domainInUrl = window.location.pathname.split('/').pop(-1);

  if (!domainInUrl) return '';
  if (!domainInUrl.match(DOMAIN_REGEX)) return '';
  return domainInUrl;
};

export const getModalPrivacy = () => {
  window.open(
    SystemDefault.PRIVACY_POLICY_URL,
    'privacy',
    'width=520,height=400,left=250,top=250,menubar=no,status=yes,toolbar=no,scrollbars=yes,resizable=yes'
  );
};

/**
 * Uses lander api to get Lander System
 * @param {string} domainName the domain to check
 * @returns {string} lander system acronym
 */
export const fetchDomainLanderSystem = async (domainName) => {
  if (!domainName) return '';
  const xRequestId = generateUUID();
  const url = `${Settings.CASHPARKING_API_PATH}/domain?domain=${domainName}`;
  const response = await fetch(url, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'X-Request-Id': xRequestId
    }
  });

  const jsonBody = await response.json();
  return jsonBody.system;
};

export const submitForm = async (domainName, { name, email, phone, comments, recaptcha }) => {
  const xRequestId = generateUUID();
  const url = `${Settings.CASHPARKING_API_PATH}/${domainName}/messageDomainOwner`;
  const response = await fetch(url, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'X-Request-Id': xRequestId,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ name, email, phone, comments, recaptchaToken: recaptcha })
  });

  if (response.status === 204) return;
  const jsonBody = await response.json();
  return jsonBody.message;
};
